export const BASE_URL = process.env.REACT_APP_API_URL;

export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

export const IS_DEVELOPER =  process.env.REACT_APP_IS_DEVELOPER